export default __webpack_public_path__ + "static/media/bit-screenshot.58c94134.png";